import React from 'react';
import PropTypes from 'prop-types';
import currencySym from 'currency-symbol-map';
import { FormattedMessage } from 'react-intl';
import { InstantBook } from '../icons';

const PriceBox = ({ currency, price, showInstaBook, wrapperClass, displayFrom = true }) => {
  return (
    <div className={wrapperClass ? wrapperClass : 'price-box-wrapper'}>
      { showInstaBook && <InstantBook className="text-white margin-sm-right" style={{ height: 24, width: 18 }} /> }
      {
        displayFrom &&
        <span className="price-box-from"><FormattedMessage id="shared_components.price_box.from" defaultMessage="from" />&nbsp;</span>
      }
      <span className="price-box-price">{ currencySym(currency) + price }</span>
      <span className="price-box-per-hour">&#47;<FormattedMessage id="shared_components.price_box.hr" defaultMessage="hr" /></span>
    </div>
  );
};

export default PriceBox;
